



























import Vue from "vue";
import iwInputCheckboxGroup from "@/encoding/components/buildingBlocks/InputCheckboxGroup.vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwTerraceSurface from "@/encoding/pages/questions/exterior/TerraceSurface.vue";
import iwTerraceOrientation from "@/encoding/pages/questions/exterior/TerraceOrientation.vue";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwTerraceSurface: iwTerraceSurface,
        iwTerraceOrientation: iwTerraceOrientation,
        iwInputCheckboxGroup: iwInputCheckboxGroup
    },
    data: function() {
        return {
            pathInStoreExists: "property.outdoor.terrace.exists",
            pathInStoreTerraceSurface: "property.outdoor.terrace.surface",
            pathInStoreTerraceOrientation: "property.outdoor.terrace.orientation",
            checkboxes: [
                {
                    value: "hasTerrace",
                    label: "terrace"
                }
            ]
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["HOUSE", "OFFICE", "COMMERCIAL", "APARTMENT", "OTHER"].indexOf(this.getPropertyType()) !== -1;
        },
        valueChecked: function(): Array<string> | void {
            if (this.$store.getters["FormModule/getValue"](this.pathInStoreExists)) {
                return ["hasTerrace"];
            }
        },
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreExists) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreTerraceSurface) ||
                this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreTerraceOrientation);
        },
        isOpen: function(): boolean {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreExists);
        },
        terraceSurface: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreTerraceSurface);
        },
        terraceSurfaceInput: function(): Vue | void {
            const accordionComponent = this.$refs.terraceSurface as Vue;
            if (accordionComponent !== null) {
                const accordionInput = accordionComponent.$refs.terraceSurfaceInput as Vue;
                if (accordionInput !== null) {
                    return accordionInput;
                }
            }
        },
        terraceOrientation: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreTerraceOrientation);
        }
    },
    mounted: function() {
        if (this.isDisplayed && this.$store.getters["FormModule/getValue"](this.pathInStoreExists) == null) {
            this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreExists, value: false});
        }
        if (!this.isDisplayed) {
            this.$store.commit("FormModule/deleteValue", this.pathInStoreExists);
        }
    },
    methods: {
        updateValueTerraceSurface: function(terraceSurface: number): void {
            if (terraceSurface == 0 && this.terraceSurface != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreTerraceSurface);
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreTerraceSurface, "value": terraceSurface});
            }
        },
        updateTerraceOrientation: function(value: string): void {
            if (value != "") {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreTerraceOrientation, "value": value});
            } else if (value == "" && this.terraceOrientation != null) {
                this.$store.commit("FormModule/deleteValue", this.pathInStoreTerraceOrientation);
            }
        },
        updateValue: function(selectedValues: Array<string>): void {
            if(selectedValues.length > 0) {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": true});
                if(this.terraceSurface == null) {
                    this.$store.dispatch("FormModule/addValue", {path: this.pathInStoreTerraceSurface, value: 1});
                }
            } else {
                this.$store.dispatch("FormModule/addValue", {"path": this.pathInStoreExists, "value": false});
                if(this.terraceSurfaceInput) {
                    this.terraceSurfaceInput.$data.internalInput = 1;
                }
                this.$store.commit("FormModule/deleteValue", this.pathInStoreTerraceSurface);
                this.$store.commit("FormModule/deleteValue", this.pathInStoreTerraceOrientation);
            }
        }
    },
});

